import { render, staticRenderFns } from "./ListImports.vue?vue&type=template&id=5228aa9e"
import script from "./ListImports.vue?vue&type=script&lang=js"
export * from "./ListImports.vue?vue&type=script&lang=js"
import style0 from "./ListImports.vue?vue&type=style&index=0&id=5228aa9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports